<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13FLMta/tc-custom/9781250014030.jpg?1730579811456" alt="This image is the cover for the book Tasteful Nudes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tasteful Nudes
      </h1>
      <p class="bookDescription body article font2">
        <b>“Call it potty-humor light: David Sedaris minus the cynicism, but plus an obsession with bodily functions . . . an engaging read.” —<i>The New York Observer</i></b><br/><br/>Hi. My name is Dave, and this is my very first collection of essays. As you can probably imagine, it pretty much has everything. In fact, if you like stories about stolen meat, animal attacks, young love, death, naked people, clergymen, rock ‘n’ roll, irritable Canadians, and prison, you have just hit a street called Easy because my book talks about all that stuff and a bunch of other stuff, too.<br/><br/>It will make you laugh, cry, and maybe even think so much that you will forget all your problems while simultaneously creating a few new ones. In limited instances it has been known to cause severe dehydration and the occasional groin pull, but honestly I don’t know what that’s about. That said, it’s probably not a bad idea to keep a glass of water handy and really stretch things out before strapping yourself in for a literary thrill ride you will want to experience again and again until you are either dead or your eyesight fails completely, whichever comes first. In fact, if I end up being wrong about any of this stuff, you can kick me right in the privates. Also, I will send you a nice ham (serves twenty). In short, you really can’t lose on this one.<br/><br/>Your man,<br/><br/>Dave Hill<br/><br/><b>“I had to go and reread certain parts again because I wanted to make sure it wasn’t the sun + tequila that was making me laugh so hard.” —<i>The Atlantic</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Hill
      </h2>
      
      <p class="authorDescription body article"><P>DAVE HILL is a comedian, writer, musician, and man-about-town originally from Cleveland but now living in New York City in an apartment all by himself because he is a grown man. He has written for <I>The New York Times</I>, <I>Salon</I>, <I>The Huffington Post</I>, <I>NY Daily News</I>, <I>Guitar World</I> and a bunch of other people, too. He is a regular contributor to public radio's <I>This American Life</I> and starred in his own TV series, <I>The King of Miami</I>, which was canceled, even though Dave really liked it. He has also appeared on Comedy Central, BBC America, MTV, and <I>Adult Swim</I> and is a regular host on HBO and Cinemax. Dave stages his own chat variety show, <I>The Dave Hill Explosion</I>, at the Upright Citizens Brigade Theatres in New York and Los Angeles, and also in London, wherever it is tolerated. Dave plays in several rock bands and is so good at the guitar that most people can't even handle it. Dave also smells really nice—ask anyone.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?269c808e